export default "__VITE_ASSET__DNplx9zu__"